var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.808,
    cy: 8.83552,
    rx: 8.83552,
    ry: 8.83552,
    fill: "url(#paint0_linear_8_289)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62371 5.38545H13.2606L17.7714 9.8963H41.2212V35.9936C40.7545 37.1608 38.9107 39.5652 35.2691 39.8453C31.6275 40.1255 10.7582 39.962 0.778735 39.8453V9.8963H10.5831L15.4853 14.6341H35.2691V33.1924",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_289",
    x1: 28.808,
    y1: 0,
    x2: 28.808,
    y2: 17.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/paymentHistory.f68453e40c7f9473672af5b1d091f807.svg";
export { ForwardRef as ReactComponent };